import CardElementSticker from './CardElementSticker';

export default CardElementSticker;
